export type XrtgRange = "5sec" | "raw" | "5min" | "15min" | "1hr" | "6hr" | "12hr" | "1day"
export type XrtgKind = "traffic" | "signal"

export const XRTG_RANGES: { id: XrtgRange; label: string }[] = [
  { id: "5sec", label: "5sec" },
  { id: "raw", label: "raw" },
  { id: "5min", label: "5min" },
  { id: "15min", label: "15min" },
  { id: "1hr", label: "1hr" },
  { id: "6hr", label: "6hr" },
  { id: "12hr", label: "12hr" },
  { id: "1day", label: "1day" },
]

export function statusDot(kind: string) {
  if (kind === "online") return "bg-emerald-500"
  if (kind === "los" || kind === "power") return "bg-amber-500"
  return "bg-slate-400"
}
